export const questions = [
	{
		q: 'Which person in your life do you feel most grateful for?',
		answered: false,
		locked: false,
		index: 0
	},
	{	
		q: 'In what ways do you wish you were more courageous?',
		answered: false,
		locked: true,
		index: 1
	},
	{
		q: 'What situations make you uncomfortable and why?',
		answered: false,
		locked: true,
		index: 2
	},
	{
		q: 'List 10 people you\'re grateful for, and why?',
		answered: false,
		locked: true,
		index: 3
	},
	{
		q: 'Why do you consider yourself worthy of love and respect?',
		answered: false,
		locked: true,
		index: 4
	},
	{
		q: 'How do you think someone could improve their intelligence?',
		answered: false,
		locked: true,
		index: 5
	},
	{
		q: 'Do you view yourself as an ethical/moral person, why or why not?',
		answered: false,
		locked: true,
		index: 6
	},
	{
		q: 'How often do you compare yourself to others, and how can you tell?',
		answered: false,
		locked: true,
		index: 7
	},
	{
		q: 'Do you love yourself, why?',
		answered: false,
		locked: true,
		index: 8
	},
	{
		q: 'When you\'re stressed out, what helps to calm you down?',
		answered: false,
		locked: true,
		index: 9
	}
]